import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'kyan';
  Sign = console.log("Develop by: Ahmed Ramadan Eng, Ahmed Abd-Elkader Eng.");
}

